export const DialCodes = [
    {
      name: "Afghanistan",
      dial_code: "+93",
      code: "AF",
      active_flag: "N",
    },
    {
      name: "Aland Islands",
      dial_code: "+358",
      code: "AX",
      active_flag: "N",
    },
    {
      name: "Albania",
      dial_code: "+355",
      code: "AL",
      active_flag: "N",
    },
    {
      name: "Algeria",
      dial_code: "+213",
      code: "DZ",
      active_flag: "N",
    },
    {
      name: "AmericanSamoa",
      dial_code: "+1684",
      code: "AS",
      active_flag: "N",
    },
    {
      name: "Andorra",
      dial_code: "+376",
      code: "AD",
      active_flag: "N",
    },
    {
      name: "Angola",
      dial_code: "+244",
      code: "AO",
      active_flag: "N",
    },
    {
      name: "Anguilla",
      dial_code: "+1264",
      code: "AI",
      active_flag: "N",
    },
    {
      name: "Antarctica",
      dial_code: "+672",
      code: "AQ",
      active_flag: "N",
    },
    {
      name: "Antigua and Barbuda",
      dial_code: "+1268",
      code: "AG",
      active_flag: "N",
    },
    {
      name: "Argentina",
      dial_code: "+54",
      code: "AR",
      active_flag: "N",
    },
    {
      name: "Armenia",
      dial_code: "+374",
      code: "AM",
      active_flag: "N",
    },
    {
      name: "Aruba",
      dial_code: "+297",
      code: "AW",
      active_flag: "N",
    },
    {
      name: "Australia",
      dial_code: "+61",
      code: "AU",
      active_flag: "N",
    },
    {
      name: "Austria",
      dial_code: "+43",
      code: "AT",
      active_flag: "N",
    },
    {
      name: "Azerbaijan",
      dial_code: "+994",
      code: "AZ",
      active_flag: "N",
    },
    {
      name: "Bahamas",
      dial_code: "+1242",
      code: "BS",
      active_flag: "N",
    },
    {
      name: "Bahrain",
      dial_code: "+973",
      code: "BH",
      active_flag: "N",
    },
    {
      name: "Bangladesh",
      dial_code: "+880",
      code: "BD",
      active_flag: "N",
    },
    {
      name: "Barbados",
      dial_code: "+1246",
      code: "BB",
      active_flag: "N",
    },
    {
      name: "Belarus",
      dial_code: "+375",
      code: "BY",
      active_flag: "N",
    },
    {
      name: "Belgium",
      dial_code: "+32",
      code: "BE",
      active_flag: "N",
    },
    {
      name: "Belize",
      dial_code: "+501",
      code: "BZ",
      active_flag: "N",
    },
    {
      name: "Benin",
      dial_code: "+229",
      code: "BJ",
      active_flag: "N",
    },
    {
      name: "Bermuda",
      dial_code: "+1441",
      code: "BM",
      active_flag: "N",
    },
    {
      name: "Bhutan",
      dial_code: "+975",
      code: "BT",
      active_flag: "N",
    },
    {
      name: "Bolivia, Plurinational State of",
      dial_code: "+591",
      code: "BO",
      active_flag: "N",
    },
    {
      name: "Bosnia and Herzegovina",
      dial_code: "+387",
      code: "BA",
      active_flag: "N",
    },
    {
      name: "Botswana",
      dial_code: "+267",
      code: "BW",
      active_flag: "N",
    },
    {
      name: "Brazil",
      dial_code: "+55",
      code: "BR",
      active_flag: "N",
    },
    {
      name: "British Indian Ocean Territory",
      dial_code: "+246",
      code: "IO",
      active_flag: "N",
    },
    {
      name: "Brunei Darussalam",
      dial_code: "+673",
      code: "BN",
      active_flag: "N",
    },
    {
      name: "Bulgaria",
      dial_code: "+359",
      code: "BG",
      active_flag: "N",
    },
    {
      name: "Burkina Faso",
      dial_code: "+226",
      code: "BF",
      active_flag: "N",
    },
    {
      name: "Burundi",
      dial_code: "+257",
      code: "BI",
      active_flag: "N",
    },
    {
      name: "Cambodia",
      dial_code: "+855",
      code: "KH",
      active_flag: "N",
    },
    {
      name: "Cameroon",
      dial_code: "+237",
      code: "CM",
      active_flag: "N",
    },
    {
      name: "Canada",
      dial_code: "+1",
      code: "CA",
      active_flag: "N",
    },
    {
      name: "Cape Verde",
      dial_code: "+238",
      code: "CV",
      active_flag: "N",
    },
    {
      name: "Cayman Islands",
      dial_code: "+ 345",
      code: "KY",
      active_flag: "N",
    },
    {
      name: "Central African Republic",
      dial_code: "+236",
      code: "CF",
      active_flag: "N",
    },
    {
      name: "Chad",
      dial_code: "+235",
      code: "TD",
      active_flag: "N",
    },
    {
      name: "Chile",
      dial_code: "+56",
      code: "CL",
      active_flag: "N",
    },
    {
      name: "China",
      dial_code: "+86",
      code: "CN",
      active_flag: "N",
    },
    {
      name: "Christmas Island",
      dial_code: "+61",
      code: "CX",
      active_flag: "N",
    },
    {
      name: "Cocos (Keeling) Islands",
      dial_code: "+61",
      code: "CC",
      active_flag: "N",
    },
    {
      name: "Colombia",
      dial_code: "+57",
      code: "CO",
      active_flag: "N",
    },
    {
      name: "Comoros",
      dial_code: "+269",
      code: "KM",
      active_flag: "N",
    },
    {
      name: "Congo",
      dial_code: "+242",
      code: "CG",
      active_flag: "N",
    },
    {
      name: "Congo, The Democratic Republic of the Congo",
      dial_code: "+243",
      code: "CD",
      active_flag: "N",
    },
    {
      name: "Cook Islands",
      dial_code: "+682",
      code: "CK",
      active_flag: "N",
    },
    {
      name: "Costa Rica",
      dial_code: "+506",
      code: "CR",
      active_flag: "N",
    },
    {
      name: "Cote d'Ivoire",
      dial_code: "+225",
      code: "CI",
      active_flag: "N",
    },
    {
      name: "Croatia",
      dial_code: "+385",
      code: "HR",
      active_flag: "N",
    },
    {
      name: "Cuba",
      dial_code: "+53",
      code: "CU",
      active_flag: "N",
    },
    {
      name: "Cyprus",
      dial_code: "+357",
      code: "CY",
      active_flag: "N",
    },
    {
      name: "Czech Republic",
      dial_code: "+420",
      code: "CZ",
      active_flag: "N",
    },
    {
      name: "Denmark",
      dial_code: "+45",
      code: "DK",
      active_flag: "N",
    },
    {
      name: "Djibouti",
      dial_code: "+253",
      code: "DJ",
      active_flag: "N",
    },
    {
      name: "Dominica",
      dial_code: "+1767",
      code: "DM",
      active_flag: "N",
    },
    {
      name: "Dominican Republic",
      dial_code: "+1849",
      code: "DO",
      active_flag: "N",
    },
    {
      name: "Ecuador",
      dial_code: "+593",
      code: "EC",
      active_flag: "N",
    },
    {
      name: "Egypt",
      dial_code: "+20",
      code: "EG",
      active_flag: "N",
    },
    {
      name: "El Salvador",
      dial_code: "+503",
      code: "SV",
      active_flag: "N",
    },
    {
      name: "Equatorial Guinea",
      dial_code: "+240",
      code: "GQ",
      active_flag: "N",
    },
    {
      name: "Eritrea",
      dial_code: "+291",
      code: "ER",
      active_flag: "N",
    },
    {
      name: "Estonia",
      dial_code: "+372",
      code: "EE",
      active_flag: "N",
    },
    {
      name: "Ethiopia",
      dial_code: "+251",
      code: "ET",
      active_flag: "N",
    },
    {
      name: "Falkland Islands (Malvinas)",
      dial_code: "+500",
      code: "FK",
      active_flag: "N",
    },
    {
      name: "Faroe Islands",
      dial_code: "+298",
      code: "FO",
      active_flag: "N",
    },
    {
      name: "Fiji",
      dial_code: "+679",
      code: "FJ",
      active_flag: "N",
    },
    {
      name: "Finland",
      dial_code: "+358",
      code: "FI",
      active_flag: "N",
    },
    {
      name: "France",
      dial_code: "+33",
      code: "FR",
      active_flag: "N",
    },
    {
      name: "French Guiana",
      dial_code: "+594",
      code: "GF",
      active_flag: "N",
    },
    {
      name: "French Polynesia",
      dial_code: "+689",
      code: "PF",
      active_flag: "N",
    },
    {
      name: "Gabon",
      dial_code: "+241",
      code: "GA",
      active_flag: "N",
    },
    {
      name: "Gambia",
      dial_code: "+220",
      code: "GM",
      active_flag: "N",
    },
    {
      name: "Georgia",
      dial_code: "+995",
      code: "GE",
      active_flag: "N",
    },
    {
      name: "Germany",
      dial_code: "+49",
      code: "DE",
      active_flag: "N",
    },
    {
      name: "Ghana",
      dial_code: "+233",
      code: "GH",
      active_flag: "N",
    },
    {
      name: "Gibraltar",
      dial_code: "+350",
      code: "GI",
      active_flag: "N",
    },
    {
      name: "Greece",
      dial_code: "+30",
      code: "GR",
      active_flag: "N",
    },
    {
      name: "Greenland",
      dial_code: "+299",
      code: "GL",
      active_flag: "N",
    },
    {
      name: "Grenada",
      dial_code: "+1473",
      code: "GD",
      active_flag: "N",
    },
    {
      name: "Guadeloupe",
      dial_code: "+590",
      code: "GP",
      active_flag: "N",
    },
    {
      name: "Guam",
      dial_code: "+1671",
      code: "GU",
      active_flag: "N",
    },
    {
      name: "Guatemala",
      dial_code: "+502",
      code: "GT",
      active_flag: "N",
    },
    {
      name: "Guernsey",
      dial_code: "+44",
      code: "GG",
      active_flag: "N",
    },
    {
      name: "Guinea",
      dial_code: "+224",
      code: "GN",
      active_flag: "N",
    },
    {
      name: "Guinea-Bissau",
      dial_code: "+245",
      code: "GW",
      active_flag: "N",
    },
    {
      name: "Guyana",
      dial_code: "+595",
      code: "GY",
      active_flag: "N",
    },
    {
      name: "Haiti",
      dial_code: "+509",
      code: "HT",
      active_flag: "N",
    },
    {
      name: "Holy See (Vatican City State)",
      dial_code: "+379",
      code: "VA",
      active_flag: "N",
    },
    {
      name: "Honduras",
      dial_code: "+504",
      code: "HN",
      active_flag: "N",
    },
    {
      name: "Hong Kong",
      dial_code: "+852",
      code: "HK",
      active_flag: "N",
    },
    {
      name: "Hungary",
      dial_code: "+36",
      code: "HU",
      active_flag: "N",
    },
    {
      name: "Iceland",
      dial_code: "+354",
      code: "IS",
      active_flag: "N",
    },
    {
      name: "India",
      dial_code: "+91",
      code: "IN",
      active_flag: "Y",
    },
    {
      name: "Indonesia",
      dial_code: "+62",
      code: "ID",
      active_flag: "N",
    },
    {
      name: "Iran, Islamic Republic of Persian Gulf",
      dial_code: "+98",
      code: "IR",
      active_flag: "N",
    },
    {
      name: "Iraq",
      dial_code: "+964",
      code: "IQ",
      active_flag: "N",
    },
    {
      name: "Ireland",
      dial_code: "+353",
      code: "IE",
      active_flag: "N",
    },
    {
      name: "Isle of Man",
      dial_code: "+44",
      code: "IM",
      active_flag: "N",
    },
    {
      name: "Israel",
      dial_code: "+972",
      code: "IL",
      active_flag: "N",
    },
    {
      name: "Italy",
      dial_code: "+39",
      code: "IT",
      active_flag: "N",
    },
    {
      name: "Jamaica",
      dial_code: "+1876",
      code: "JM",
      active_flag: "N",
    },
    {
      name: "Japan",
      dial_code: "+81",
      code: "JP",
      active_flag: "N",
    },
    {
      name: "Jersey",
      dial_code: "+44",
      code: "JE",
      active_flag: "N",
    },
    {
      name: "Jordan",
      dial_code: "+962",
      code: "JO",
      active_flag: "N",
    },
    {
      name: "Kazakhstan",
      dial_code: "+77",
      code: "KZ",
      active_flag: "N",
    },
    {
      name: "Kenya",
      dial_code: "+254",
      code: "KE",
      active_flag: "N",
    },
    {
      name: "Kiribati",
      dial_code: "+686",
      code: "KI",
      active_flag: "N",
    },
    {
      name: "Korea, Democratic People's Republic of Korea",
      dial_code: "+850",
      code: "KP",
      active_flag: "N",
    },
    {
      name: "Korea, Republic of South Korea",
      dial_code: "+82",
      code: "KR",
      active_flag: "N",
    },
    {
      name: "Kuwait",
      dial_code: "+965",
      code: "KW",
      active_flag: "N",
    },
    {
      name: "Kyrgyzstan",
      dial_code: "+996",
      code: "KG",
      active_flag: "N",
    },
    {
      name: "Laos",
      dial_code: "+856",
      code: "LA",
      active_flag: "N",
    },
    {
      name: "Latvia",
      dial_code: "+371",
      code: "LV",
      active_flag: "N",
    },
    {
      name: "Lebanon",
      dial_code: "+961",
      code: "LB",
      active_flag: "N",
    },
    {
      name: "Lesotho",
      dial_code: "+266",
      code: "LS",
      active_flag: "N",
    },
    {
      name: "Liberia",
      dial_code: "+231",
      code: "LR",
      active_flag: "Y",
    },
    {
      name: "Libyan Arab Jamahiriya",
      dial_code: "+218",
      code: "LY",
      active_flag: "N",
    },
    {
      name: "Liechtenstein",
      dial_code: "+423",
      code: "LI",
      active_flag: "N",
    },
    {
      name: "Lithuania",
      dial_code: "+370",
      code: "LT",
      active_flag: "N",
    },
    {
      name: "Luxembourg",
      dial_code: "+352",
      code: "LU",
      active_flag: "N",
    },
    {
      name: "Macao",
      dial_code: "+853",
      code: "MO",
      active_flag: "N",
    },
    {
      name: "Macedonia",
      dial_code: "+389",
      code: "MK",
      active_flag: "N",
    },
    {
      name: "Madagascar",
      dial_code: "+261",
      code: "MG",
      active_flag: "N",
    },
    {
      name: "Malawi",
      dial_code: "+265",
      code: "MW",
      active_flag: "N",
    },
    {
      name: "Malaysia",
      dial_code: "+60",
      code: "MY",
      active_flag: "N",
    },
    {
      name: "Maldives",
      dial_code: "+960",
      code: "MV",
      active_flag: "N",
    },
    {
      name: "Mali",
      dial_code: "+223",
      code: "ML",
      active_flag: "N",
    },
    {
      name: "Malta",
      dial_code: "+356",
      code: "MT",
      active_flag: "N",
    },
    {
      name: "Marshall Islands",
      dial_code: "+692",
      code: "MH",
      active_flag: "N",
    },
    {
      name: "Martinique",
      dial_code: "+596",
      code: "MQ",
      active_flag: "N",
    },
    {
      name: "Mauritania",
      dial_code: "+222",
      code: "MR",
      active_flag: "N",
    },
    {
      name: "Mauritius",
      dial_code: "+230",
      code: "MU",
      active_flag: "N",
    },
    {
      name: "Mayotte",
      dial_code: "+262",
      code: "YT",
      active_flag: "N",
    },
    {
      name: "Mexico",
      dial_code: "+52",
      code: "MX",
      active_flag: "N",
    },
    {
      name: "Micronesia, Federated States of Micronesia",
      dial_code: "+691",
      code: "FM",
      active_flag: "N",
    },
    {
      name: "Moldova",
      dial_code: "+373",
      code: "MD",
      active_flag: "N",
    },
    {
      name: "Monaco",
      dial_code: "+377",
      code: "MC",
      active_flag: "N",
    },
    {
      name: "Mongolia",
      dial_code: "+976",
      code: "MN",
      active_flag: "N",
    },
    {
      name: "Montenegro",
      dial_code: "+382",
      code: "ME",
      active_flag: "N",
    },
    {
      name: "Montserrat",
      dial_code: "+1664",
      code: "MS",
      active_flag: "N",
    },
    {
      name: "Morocco",
      dial_code: "+212",
      code: "MA",
      active_flag: "N",
    },
    {
      name: "Mozambique",
      dial_code: "+258",
      code: "MZ",
      active_flag: "N",
    },
    {
      name: "Myanmar",
      dial_code: "+95",
      code: "MM",
      active_flag: "N",
    },
    {
      name: "Namibia",
      dial_code: "+264",
      code: "NA",
      active_flag: "N",
    },
    {
      name: "Nauru",
      dial_code: "+674",
      code: "NR",
      active_flag: "N",
    },
    {
      name: "Nepal",
      dial_code: "+977",
      code: "NP",
      active_flag: "N",
    },
    {
      name: "Netherlands",
      dial_code: "+31",
      code: "NL",
      active_flag: "N",
    },
    {
      name: "Netherlands Antilles",
      dial_code: "+599",
      code: "AN",
      active_flag: "N",
    },
    {
      name: "New Caledonia",
      dial_code: "+687",
      code: "NC",
      active_flag: "N",
    },
    {
      name: "New Zealand",
      dial_code: "+64",
      code: "NZ",
      active_flag: "N",
    },
    {
      name: "Nicaragua",
      dial_code: "+505",
      code: "NI",
      active_flag: "N",
    },
    {
      name: "Niger",
      dial_code: "+227",
      code: "NE",
      active_flag: "N",
    },
    {
      name: "Nigeria",
      dial_code: "+234",
      code: "NG",
      active_flag: "Y",
    },
    {
      name: "Niue",
      dial_code: "+683",
      code: "NU",
      active_flag: "N",
    },
    {
      name: "Norfolk Island",
      dial_code: "+672",
      code: "NF",
      active_flag: "N",
    },
    {
      name: "Northern Mariana Islands",
      dial_code: "+1670",
      code: "MP",
      active_flag: "N",
    },
    {
      name: "Norway",
      dial_code: "+47",
      code: "NO",
      active_flag: "N",
    },
    {
      name: "Oman",
      dial_code: "+968",
      code: "OM",
      active_flag: "N",
    },
    {
      name: "Pakistan",
      dial_code: "+92",
      code: "PK",
      active_flag: "N",
    },
    {
      name: "Palau",
      dial_code: "+680",
      code: "PW",
      active_flag: "N",
    },
    {
      name: "Palestinian Territory, Occupied",
      dial_code: "+970",
      code: "PS",
      active_flag: "N",
    },
    {
      name: "Panama",
      dial_code: "+507",
      code: "PA",
      active_flag: "N",
    },
    {
      name: "Papua New Guinea",
      dial_code: "+675",
      code: "PG",
      active_flag: "N",
    },
    {
      name: "Paraguay",
      dial_code: "+595",
      code: "PY",
      active_flag: "N",
    },
    {
      name: "Peru",
      dial_code: "+51",
      code: "PE",
      active_flag: "N",
    },
    {
      name: "Philippines",
      dial_code: "+63",
      code: "PH",
      active_flag: "N",
    },
    {
      name: "Pitcairn",
      dial_code: "+872",
      code: "PN",
      active_flag: "N",
    },
    {
      name: "Poland",
      dial_code: "+48",
      code: "PL",
      active_flag: "N",
    },
    {
      name: "Portugal",
      dial_code: "+351",
      code: "PT",
      active_flag: "N",
    },
    {
      name: "Puerto Rico",
      dial_code: "+1939",
      code: "PR",
      active_flag: "Y",
    },
    {
      name: "Qatar",
      dial_code: "+974",
      code: "QA",
      active_flag: "N",
    },
    {
      name: "Romania",
      dial_code: "+40",
      code: "RO",
      active_flag: "N",
    },
    {
      name: "Russia",
      dial_code: "+7",
      code: "RU",
      active_flag: "N",
    },
    {
      name: "Rwanda",
      dial_code: "+250",
      code: "RW",
      active_flag: "N",
    },
    {
      name: "Reunion",
      dial_code: "+262",
      code: "RE",
      active_flag: "N",
    },
    {
      name: "Saint Barthelemy",
      dial_code: "+590",
      code: "BL",
      active_flag: "N",
    },
    {
      name: "Saint Helena, Ascension and Tristan Da Cunha",
      dial_code: "+290",
      code: "SH",
      active_flag: "N",
    },
    {
      name: "Saint Kitts and Nevis",
      dial_code: "+1869",
      code: "KN",
      active_flag: "N",
    },
    {
      name: "Saint Lucia",
      dial_code: "+1758",
      code: "LC",
      active_flag: "N",
    },
    {
      name: "Saint Martin",
      dial_code: "+590",
      code: "MF",
      active_flag: "N",
    },
    {
      name: "Saint Pierre and Miquelon",
      dial_code: "+508",
      code: "PM",
      active_flag: "N",
    },
    {
      name: "Saint Vincent and the Grenadines",
      dial_code: "+1784",
      code: "VC",
      active_flag: "N",
    },
    {
      name: "Samoa",
      dial_code: "+685",
      code: "WS",
      active_flag: "N",
    },
    {
      name: "San Marino",
      dial_code: "+378",
      code: "SM",
      active_flag: "N",
    },
    {
      name: "Sao Tome and Principe",
      dial_code: "+239",
      code: "ST",
      active_flag: "N",
    },
    {
      name: "Saudi Arabia",
      dial_code: "+966",
      code: "SA",
      active_flag: "Y",
    },
    {
      name: "Senegal",
      dial_code: "+221",
      code: "SN",
      active_flag: "N",
    },
    {
      name: "Serbia",
      dial_code: "+381",
      code: "RS",
      active_flag: "N",
    },
    {
      name: "Seychelles",
      dial_code: "+248",
      code: "SC",
      active_flag: "N",
    },
    {
      name: "Sierra Leone",
      dial_code: "+232",
      code: "SL",
      active_flag: "N",
    },
    {
      name: "Singapore",
      dial_code: "+65",
      code: "SG",
      active_flag: "N",
    },
    {
      name: "Slovakia",
      dial_code: "+421",
      code: "SK",
      active_flag: "N",
    },
    {
      name: "Slovenia",
      dial_code: "+386",
      code: "SI",
      active_flag: "N",
    },
    {
      name: "Solomon Islands",
      dial_code: "+677",
      code: "SB",
      active_flag: "N",
    },
    {
      name: "Somalia",
      dial_code: "+252",
      code: "SO",
      active_flag: "N",
    },
    {
      name: "South Africa",
      dial_code: "+27",
      code: "ZA",
      active_flag: "N",
    },
    {
      name: "South Sudan",
      dial_code: "+211",
      code: "SS",
      active_flag: "N",
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      dial_code: "+500",
      code: "GS",
      active_flag: "N",
    },
    {
      name: "Spain",
      dial_code: "+34",
      code: "ES",
      active_flag: "N",
    },
    {
      name: "Sri Lanka",
      dial_code: "+94",
      code: "LK",
      active_flag: "N",
    },
    {
      name: "Sudan",
      dial_code: "+249",
      code: "SD",
      active_flag: "N",
    },
    {
      name: "Suriname",
      dial_code: "+597",
      code: "SR",
      active_flag: "N",
    },
    {
      name: "Svalbard and Jan Mayen",
      dial_code: "+47",
      code: "SJ",
      active_flag: "N",
    },
    {
      name: "Swaziland",
      dial_code: "+268",
      code: "SZ",
      active_flag: "N",
    },
    {
      name: "Sweden",
      dial_code: "+46",
      code: "SE",
      active_flag: "N",
    },
    {
      name: "Switzerland",
      dial_code: "+41",
      code: "CH",
      active_flag: "N",
    },
    {
      name: "Syrian Arab Republic",
      dial_code: "+963",
      code: "SY",
      active_flag: "N",
    },
    {
      name: "Taiwan",
      dial_code: "+886",
      code: "TW",
      active_flag: "N",
    },
    {
      name: "Tajikistan",
      dial_code: "+992",
      code: "TJ",
      active_flag: "N",
    },
    {
      name: "Tanzania, United Republic of Tanzania",
      dial_code: "+255",
      code: "TZ",
      active_flag: "N",
    },
    {
      name: "Thailand",
      dial_code: "+66",
      code: "TH",
      active_flag: "N",
    },
    {
      name: "Timor-Leste",
      dial_code: "+670",
      code: "TL",
      active_flag: "N",
    },
    {
      name: "Togo",
      dial_code: "+228",
      code: "TG",
      active_flag: "N",
    },
    {
      name: "Tokelau",
      dial_code: "+690",
      code: "TK",
      active_flag: "N",
    },
    {
      name: "Tonga",
      dial_code: "+676",
      code: "TO",
      active_flag: "N",
    },
    {
      name: "Trinidad and Tobago",
      dial_code: "+1868",
      code: "TT",
      active_flag: "N",
    },
    {
      name: "Tunisia",
      dial_code: "+216",
      code: "TN",
      active_flag: "N",
    },
    {
      name: "Turkey",
      dial_code: "+90",
      code: "TR",
      active_flag: "N",
    },
    {
      name: "Turkmenistan",
      dial_code: "+993",
      code: "TM",
      active_flag: "N",
    },
    {
      name: "Turks and Caicos Islands",
      dial_code: "+1649",
      code: "TC",
      active_flag: "N",
    },
    {
      name: "Tuvalu",
      dial_code: "+688",
      code: "TV",
      active_flag: "N",
    },
    {
      name: "Uganda",
      dial_code: "+256",
      code: "UG",
      active_flag: "N",
    },
    {
      name: "Ukraine",
      dial_code: "+380",
      code: "UA",
      active_flag: "N",
    },
    {
      name: "United Arab Emirates",
      dial_code: "+971",
      code: "AE",
      active_flag: "Y",
    },
    {
      name: "United Kingdom",
      dial_code: "+44",
      code: "GB",
      active_flag: "N",
    },
    {
      name: "United States",
      dial_code: "+1",
      code: "US",
      active_flag: "Y",
    },
    {
      name: "Uruguay",
      dial_code: "+598",
      code: "UY",
      active_flag: "N",
    },
    {
      name: "Uzbekistan",
      dial_code: "+998",
      code: "UZ",
      active_flag: "N",
    },
    {
      name: "Vanuatu",
      dial_code: "+678",
      code: "VU",
      active_flag: "N",
    },
    {
      name: "Venezuela, Bolivarian Republic of Venezuela",
      dial_code: "+58",
      code: "VE",
      active_flag: "N",
    },
    {
      name: "Vietnam",
      dial_code: "+84",
      code: "VN",
      active_flag: "N",
    },
    {
      name: "Virgin Islands, British",
      dial_code: "+1284",
      code: "VG",
      active_flag: "N",
    },
    {
      name: "Virgin Islands, U.S.",
      dial_code: "+1340",
      code: "VI",
      active_flag: "N",
    },
    {
      name: "Wallis and Futuna",
      dial_code: "+681",
      code: "WF",
      active_flag: "N",
    },
    {
      name: "Yemen",
      dial_code: "+967",
      code: "YE",
      active_flag: "N",
    },
    {
      name: "Zambia",
      dial_code: "+260",
      code: "ZM",
      active_flag: "N",
    },
    {
      name: "Zimbabwe",
      dial_code: "+263",
      code: "ZW",
      active_flag: "N",
    },
  ];
  